var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"mt-4"},[_c('strong',[_vm._v("Send During Hours ("+_vm._s(_vm.send_during_timezone)+")")])]),_c('m-daily-schedule',{attrs:{"value":_vm.template.send_during,"read_only":_vm.read_only},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }